import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import ShowLoading from '../helperComponent/ShowLoading';
import coursesImg from '../../assets/graduation.png';
import CourseItem from './CourseItem';
import AddCourseForm from './AddCourseForm';
import './CourseStyle.css';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();

const CoursesPage = () => {
  const [courses, setCourses] = useState([]);
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(1);
  const [showAddCourse, setAddCourse] = useState(false);
  const [buttonText, setButtonText] = useState('Add Course');
  const [showLoading, setShowLoading] = useState(true);

  let history = useHistory();

  const uname = JSON.parse(localStorage.getItem('uname'));
  let fetchURL = `https://stucharge.bakersbrisk.com/api/courseapi?username=${uname}&page=${page}`;
  const URL = 'https://stucharge.bakersbrisk.com/api/courseapi';
  const AuthStr = process.env.REACT_APP_AUTH_STR;

  // fetch data
  useEffect(() => {
    axios
      .get(fetchURL, { headers: { Authorization: AuthStr } })
      .then((response) => {
        // If request is good...
        if (response.status === 200) {
          if (
            response.data.length > 0 &&
            !response.data[response.data.length - 1].has_next
          )
            setNext(0);
          setCourses(response.data);
          setShowLoading(false);
        } else if (response.status !== 200)
          toast.error('Something went wrong, please refresh');
      })
      .catch((error) => {
        if (error) console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchURL]);

  // on click handler
  const onClickHandler = () => {
    setAddCourse(!showAddCourse);
    setButtonText(buttonText === 'Add Course' ? 'Close' : 'Add Course');
  };

  // adding notes to database
  const addCourse = ({ title, price, offerPrice, description, image, sub }) => {
    var bodyFormData = new FormData();
    bodyFormData.append('title', title);
    bodyFormData.append('price', price);
    bodyFormData.append('image', image);
    bodyFormData.append('offer_price', offerPrice);
    bodyFormData.append('description', description);
    bodyFormData.append('username', uname);
    bodyFormData.append('subject', sub);
    // send course data to server
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201)
          toast.success('Course added successfully!');
        history.push('/home');
        history.push('/courses');
      })
      .catch((error) => {
        toast.error('Something went wrong, please try again');
      });
  };

  return (
    <main>
      <div className='main_container'>
        <div className='main_title'>
          <img src={coursesImg} alt='courses' width='50' />
          <div className='main_greeting'>
            <h1>Your Courses</h1>
            <p>Your active courses are available here </p>
            {showLoading && <ShowLoading />}
          </div>
        </div>

        <div className='add-notes'>
          <button
            onClick={onClickHandler}
            style={{
              background: showAddCourse ? '#ef4f4f' : '#ff7171',
            }}
          >
            {buttonText}
          </button>
        </div>

        {showAddCourse && <AddCourseForm addCourse={addCourse} />}

        {courses.length > 0 ? (
          <>
            <div className='courses-container'>
              <div className='main_cards'>
                {courses.map((course) => (
                  <CourseItem course={course} key={course.id} />
                ))}
              </div>
            </div>
            <div className='change-page'>
              {page > 1 ? (
                <button
                  type='button'
                  onClick={() => setPage(page > 1 ? page - 1 : 1)}
                >
                  Prev
                </button>
              ) : null}
              {next === 1 ? (
                <button type='button' onClick={() => setPage(page + 1)}>
                  Next
                </button>
              ) : null}
            </div>
          </>
        ) : (
          <div className='alert-heading'>
            <h1>No Course added</h1>
          </div>
        )}
      </div>
    </main>
  );
};

export default CoursesPage;
